import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 34.892"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(1.18559 0 0 1.18559 -965.773 -331.784)" }, [
      _createElementVNode("path", {
        d: "M817.112 282.971c-1.258 1.343-2.046 3.299-2.015 5.139.064 3.845 1.797 5.3 4.568 10.592.999 2.328 2.04 4.792 3.031 8.873.138.602.272 1.16.335 1.21.062.048.196-.513.334-1.115.99-4.081 2.033-6.543 3.031-8.871 2.771-5.292 4.504-6.748 4.568-10.592.031-1.84-.759-3.798-2.017-5.14-1.437-1.535-3.605-2.67-5.916-2.717-2.312-.048-4.481 1.087-5.919 2.621z",
        style: {"display":"inline","opacity":"1","fill-opacity":"1","stroke-miterlimit":"4","stroke-dasharray":"none","stroke-opacity":"1"}
      }),
      _createElementVNode("circle", {
        r: "3.035",
        cy: "288.253",
        cx: "823.031",
        style: {"display":"inline","opacity":"1","fill-opacity":"1","stroke-width":"0"}
      })
    ], -1 /* HOISTED */)
  ])))
}
export default { render: render }